import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import { IMyDpOptions } from 'mydatepicker';
import { USER_ROLES, API_BASE_URL, ENDPOINTS } from '../app.config';
import Utils from '../app.utilities';
import { CompanyService  } from '../company.service';
import { UserInfoService } from '../shared/user-info.service';
import { TranslateService } from '@ngx-translate/core';

const utilities = new Utils();

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css'],
  // Is already provided in ../app.module.ts
  //  but the UserInfoService, in the constructor, needs access to ActivatedRoute.params
  //  https://stackoverflow.com/questions/39977962/angular-2-0-2-activatedroute-is-empty-in-a-service
  providers: [UserInfoService]
})
export class CompanyComponent implements OnInit {
  sub: any;
  gettingPlaylistsInProgress: boolean;
  playlistdevicesCurrentPage: number;
  userRole: string;
  businesOwnerName : string;
  companyName: string;
  companyId: any;
  disconnectedDevices: any;
  devicesCurrentPage: number;
  totalPages: number;
  devicesTotal: number;
  devicesPerPage: number;
  gettingDevicesInProgress: boolean;
  route: ActivatedRoute;
  companyService: CompanyService;
  userInfoService : UserInfoService;
  pingVisionConnect: boolean;
  metals: boolean;
  currencies: boolean;
  businessOwnerIdLocalStorage = localStorage.getItem('businessOwnerId');
  public serverurl = 'http://194.33.12.28:8081';
  yes: string;
  no: string;

  constructor(
    route           : ActivatedRoute,
    companyService  : CompanyService,
    userInfoService : UserInfoService,
    private translate: TranslateService
  )
    {
      this.route = route;
      this.companyService  = companyService;
      this.userInfoService = userInfoService;
    }

  sendRequestToVisionConnect() {
    axios.get(API_BASE_URL + 'online')
    .then(response => {
      this.pingVisionConnect = response.data.online;
    }, error => {
      this.pingVisionConnect = false;
    })
  }

  getMetals() {
    const _self = this;
    axios.get(API_BASE_URL + '/metals').then(response => {
       if(response.data.length){
         _self.metals = true;
       } else {
         _self.metals = false;
       }
    }, error => {
      _self.metals = false;
    })
  }

  getCurrencies() {
    const _self = this;
    axios.get(API_BASE_URL + '/currencies').then(response => {
      if(response.data.length){
        _self.currencies = true;
      } else {
        _self.currencies = false;
      }
    }, error => {
      _self.currencies = false;
    })
  }

  ngOnInit() {
    this.gettingPlaylistsInProgress = false;
    this.devicesCurrentPage = 1;
    this.playlistdevicesCurrentPage = 1;
    this.disconnectedDevices = [];
    this.sendRequestToVisionConnect();
    this.getCurrencies();
    this.getMetals();
    this.sub = this.route.params.subscribe(params => {
      this.companyId = params.companyId;
      this.companyService.setCompanyId(params.companyId);
      this.getUserInfo();
      this.getDisconnectedDevices();
    });
    this.translate.get('SHARED.Labels.yes').subscribe((res: string) => {
      this.yes = res;
    });
    this.translate.get('SHARED.Labels.no').subscribe((res: string) => {
      this.no = res;
    });

  }

  generateDevicePages() {
    if (!this.totalPages) {
      return [];
    }
    const arr = [];
    for (let i = 0; i < this.totalPages; i++) {
      arr.push(i + 1);
    }
    return arr;
  }

  loadDevices(page, isDisabled) {
    if (!isDisabled && !this.gettingDevicesInProgress) {
      this.devicesCurrentPage = page;
      this.getDisconnectedDevices();
    }
  }

  initPaging(response) {
    const _self = this;
    _self.devicesTotal = parseInt(response.headers['total'], 10);
    _self.devicesPerPage = parseInt(response.headers['per-page'], 10);
    _self.totalPages = Math.floor(
      _self.devicesTotal % _self.devicesPerPage,
    ) === 0
      ? _self.devicesTotal / _self.devicesPerPage
      : Math.floor(_self.devicesTotal / _self.devicesPerPage) + 1;
  }

  getDisconnectedDevices() {
    const _self = this;
    if (_self.gettingDevicesInProgress) {
      return;
    }
    _self.gettingDevicesInProgress = true;
    axios.get(ENDPOINTS.DASHBOARD_DEVICES.replace(':companyId', this.companyId))
      .then(response => {
        _self.initPaging(response);
        axios
          .get(
            ENDPOINTS.DASHBOARD_DEVICES.replace(':companyId', this.companyId) +
            '?page=' +
            _self.devicesCurrentPage +
            '&per_page=' +
            _self.devicesPerPage,
          )
          .then(pagedResponse => {
            _self.disconnectedDevices = pagedResponse.data;
            _self.gettingDevicesInProgress = false;
          });
      }, error => {
        _self.gettingDevicesInProgress = false;
      })
  }

  getUserInfo() {
     const _self = this;
     this.userInfoService.getInformations()
       .subscribe(userInfo => {
         _self.userRole        = userInfo.userRole;
         _self.companyName     = userInfo.companyName;
        _self.businesOwnerName = userInfo.businesOwnerName;
       });
   }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/company/company.component.ts